{
  "addRevenue": "Thêm khoản thu",
  "recordMenu": "Ghi sổ",
  "recordMenuIncome": "Thêm khoản thu",
  "recordMenuExpense": "Thêm khoản chi",
  "dashboard": {
    "title": "Sổ thu chi",
    "subtitle": "Theo dõi thu nhập, chi phí và lợi nhuận theo kỳ.",
    "kpi": {
      "income": "Thu",
      "incomeSplit": "hoá đơn {{fromInvoices}} · khác {{other}}",
      "expenses": "Chi phí",
      "netProfit": "Lợi nhuận",
      "expensesCount": "{{count}} khoản chi"
    },
    "sourceBreakdown": {
      "title": "Khoản thu theo nguồn",
      "empty": "Chưa có khoản thu trong kỳ này."
    },
    "categoryBreakdown": {
      "title": "Chi phí theo danh mục",
      "empty": "Chưa có chi phí trong kỳ này.",
      "count": "{{count}} khoản",
      "addFirst": "Thêm khoản chi"
    },
    "viewAll": "Xem tất cả →",
    "viewIncome": "Xem khoản thu"
  },
  "export": {
    "button": "Tải sổ thu chi",
    "downloading": "Đang tải...",
    "success": "Đã tải xuống",
    "error": "Lỗi khi tải xuống",
    "form": {
      "report": "Báo cáo doanh thu",
      "s1a": "Sổ doanh thu",
      "s2": "Sổ chi tiết doanh thu & chi phí",
      "misa": "Xuất cho MISA"
    },
    "disclaimer": "Sổ/báo cáo được lập từ dữ liệu trên LopHoc (học phí và chi phí bạn nhập). Vui lòng đối chiếu với nghĩa vụ kê khai thực tế của bạn."
  },
  "period": {
    "month": "Tháng",
    "quarter": "Quý",
    "year": "Năm",
    "label": {
      "month": "Tháng {{month}}/{{year}}",
      "quarter": "Quý {{quarter}}/{{year}}",
      "year": "Năm {{year}}"
    },
    "prev": "Kỳ trước",
    "next": "Kỳ sau"
  },
  "expenses": {
    "title": "Chi phí",
    "subtitle": "Danh sách các khoản chi.",
    "add": "Thêm chi phí",
    "search": "Tìm theo cửa hàng, người nhận...",
    "filter": {
      "all": "Tất cả"
    },
    "empty": {
      "title": "Chưa có khoản chi nào",
      "subtitle": "Ghi lại tiền thuê phòng, lương, mua sắm để sổ thu chi phản ánh đúng lãi.",
      "cta": "Ghi khoản chi",
      "filtered": "Không có chi phí nào khớp bộ lọc."
    },
    "table": {
      "date": "Ngày",
      "vendor": "Trả cho",
      "client": "Khách hàng",
      "category": "Danh mục",
      "amount": "Số tiền",
      "notes": "Ghi chú",
      "receipt": "Hoá đơn"
    }
  },
  "income": {
    "title": "Khoản thu",
    "subtitle": "Tiền đã thực nhận trong kỳ.",
    "empty": "Chưa có khoản thu trong kỳ này.",
    "emptyTitle": "Chưa có khoản thu nào",
    "emptyBody": "Tiền về từ hoá đơn và các khoản ghi tay đều nằm ở đây.",
    "col": {
      "date": "Ngày",
      "content": "Diễn giải",
      "source": "Nguồn",
      "invoice": "Hoá đơn / khách",
      "amount": "Số tiền"
    },
    "source": {
      "SEPAY": "Chuyển khoản (QR)",
      "CASH": "Tiền mặt",
      "MANUAL_BANK": "Chuyển khoản ngoài",
      "ECOMMERCE": "Sàn TMĐT",
      "OTHER": "Khác"
    },
    "loading": "Đang tải..."
  },
  "drawer": {
    "create": {
      "title": "Thêm chi phí",
      "subtitle": "Nhập thông tin chi phí bên dưới."
    },
    "edit": {
      "title": "Chỉnh sửa chi phí"
    },
    "field": {
      "amount": "Số tiền (VND) *",
      "amountPlaceholder": "1.250.000",
      "category": "Danh mục *",
      "date": "Ngày *",
      "vendor": "Trả cho",
      "vendorPlaceholder": "Cửa hàng, chủ phòng, người nhận...",
      "client": "Khách hàng",
      "noClient": "(Không gắn khách)",
      "notes": "Ghi chú",
      "notesPlaceholder": "Mô tả thêm..."
    },
    "category": {
      "custom": "+ Tự do",
      "customPlaceholder": "Nhập danh mục..."
    },
    "cancel": "Huỷ",
    "save": "Lưu",
    "saving": "Đang lưu...",
    "saveChanges": "Lưu thay đổi",
    "delete": "Xoá",
    "deleteConfirm": {
      "title": "Xoá chi phí?",
      "body": "Hành động này không thể hoàn tác.",
      "action": "Xoá"
    }
  },
  "toast": {
    "created": "Đã thêm chi phí",
    "updated": "Đã cập nhật",
    "deleted": "Đã xoá chi phí",
    "error": "Có lỗi, thử lại"
  },
  "locked": {
    "title": "Nâng cấp Pro để dùng Sổ thu chi",
    "body": "Gói hiện tại chưa bao gồm ghi và sửa Sổ thu chi, bạn vẫn xem, tải sổ và xoá dữ liệu của mình bình thường. Nâng cấp lên Pro để ghi khoản thu/chi mới và xem phân tích lợi nhuận.",
    "cta": "Nâng cấp",
    "upsellTitle": "Ghi và sửa cần gói Pro",
    "upsellBody": "Bạn vẫn xem, xuất và xoá được sổ thu chi của mình trên mọi gói. Nâng cấp lên Pro để ghi khoản thu/chi mới và sửa các khoản đã có."
  }
}
